import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { clearLogoutReason, logoutReason } from "../../util/idle";
import { IDLE_NOTICE } from "./IdleLogout";
import "./Session.css";

// On the logged-out pages after a logout for inactivity (IdleLogout, or the
// site opened again after a long pause): why, and a way back in. Gone after
// closing it or logging in (App.js).
const SessionNotice = () => {
  const [reason, setReason] = useState(logoutReason);
  const { pathname } = useLocation();
  if (reason !== "idle") return null;

  const close = () => {
    clearLogoutReason();
    setReason(null);
  };

  return (
    <div className="session-notice" role="status">
      <span>{IDLE_NOTICE}</span>
      {pathname !== "/auth" && <Link to="/auth">Log in again</Link>}
      <button type="button" className="session-notice__close" onClick={close} aria-label="Close the notice">×</button>
    </div>
  );
};

export default SessionNotice;
